<template>
  <el-table
          :data="tableData"
          border
          stripe
          style="width: 100%">
    <el-table-column
            fixed
            type="index"
            label="序号"
            :index="indexMethod"
            width="100">
    </el-table-column>
    <el-table-column
            prop="couponsType"
            label="优惠券类型"
            width="180">
    </el-table-column>
    <el-table-column
            prop="couponsName"
            label="优惠券名称"
            width="180">
    </el-table-column>
    <el-table-column
            prop="faceValue"
            label="优惠面值"
            width="100">
    </el-table-column>
    <el-table-column
            prop="couponsCount"
            label="可用次数"
            width="100">
    </el-table-column>
    <el-table-column
            prop="validityNum"
            label="自领取后的有效天数"
            width="180">
    </el-table-column>
    <el-table-column
            prop="createDate"
            label="创建时间"
            width="180">
    </el-table-column>
<!--    <el-table-column-->
<!--            prop="endReceiveDate"-->
<!--            label="最终领取期限"-->
<!--            width="180">-->
<!--    </el-table-column>-->
    <el-table-column
            prop="supportScenarios"
            label="支持场景"
            width="180">
    </el-table-column>
    <el-table-column
            prop="getScenarios"
            label="领取方式"
            width="180">
    </el-table-column>
    <el-table-column
            prop="oneCount"
            label="单用户可领取次数"
            width="180">
    </el-table-column>
    <el-table-column
            prop="getCount"
            label="被领取总次数"
            width="180">
    </el-table-column>
    <el-table-column
            fixed="right"
            label="操作"
            width="150">
      <template slot-scope="scope">
        <el-button type="text" size="small" @click="view(scope.row.id)">查看</el-button>
        <el-button type="text" size="small" @click="update(scope.row.id)">修改</el-button>
        <el-button type="text" size="small" @click="del(scope.row.id)">
          <p class="red">删除</p>
        </el-button>
      </template>
    </el-table-column>
  </el-table>
</template>

<script>
  export default {
    name: "MessageTable",
    props: {
      tableData: Array
    },
    data() {
      return {
      }
    },
    methods: {
      indexMethod(index) {
        return index+1;
      },
      view(id){
        this.$emit("view",id)
      },
      update(id){
        this.$emit("update",id)
      },
      del(id){
        this.$emit("del",id)
      }
    },
  }
</script>

<style scoped>
  .red{
    color: red;
  }
</style>
